import React from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

import { FormElementMeta } from '@people-science/forms-core';

import { H3, P } from '../../../../components/Typography';
import Spacer from '../../../../components/Spacer';

const StyledQuestion = styled.View<{ isDesktop: boolean }>`
  width: 100%;
`;

const StyledP = styled(P)`
  margin-top: 4px;
`;

const FormElementQuestion: React.FC<{ element: FormElementMeta<any, any> }> = ({
  element
}) => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  return (
    <StyledQuestion isDesktop={isDesktop}>
      {Boolean(element.title) && (
        <H3 color='dark' padding={1}>
          {element.title}
        </H3>
      )}
      {Boolean(element.description) && (
        <StyledP color='dark'>{element.description}</StyledP>
      )}
      <Spacer size={2} />
    </StyledQuestion>
  );
};

export default FormElementQuestion;
